import React from 'react'
import { HashRouter as Router, Redirect, Route } from 'react-router-dom'
import './app.less'
import './components/Layout.less'
import AsyncWrap from './components/AsyncWrap'
import Util from './util/util'
import Env from './util/env'
import Auth from "./routes/Passport/Auth";
import Login from './routes/Passport/Login'
import Logout from './routes/Passport/Logout'

import { Provider } from "react-redux";
import { store } from "./redux/store";

import { DOC_TITLE } from './constants/conf'

import initManager from './initManager';

const Home = AsyncWrap (() => import('./routes/Home'))

let $rootHtml = document.getElementById ("rootHtml");

window.onresize = function () {
  resizeFont ()
}

function resizeFont() {
  let fs = Util.getResizeFontSize (300, 640)
  $rootHtml.style.fontSize = fs + 'px'
}

resizeFont ()

function initDocTitle() {
  document.title = DOC_TITLE;
}

initDocTitle();

initManager();


export default () => {
  return (
    <Provider store={store}>
      <Router>
        <div className="pg-wrap">
          <PrivateRoute exact path="/" component={Home}/>
          <Route path="/auth" component={Auth} />
          <Route path="/login" component={Login}/>
          <Route path="/logout" component={Logout}/>
        </div>
      </Router>
    </Provider>
  )
};

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            Env.isLogin () 
            || process.env.CHANNEL === "offline" 
            || window.OVERRIDE_SKIP_LDAP ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                      pathname: "/auth",
                      state: { from: props.location, referrer: window.location.href  }
                    }}
                />
            )
        }
    />
);



// WEBPACK FOOTER //
// ./src/App.js